import React, { useEffect, useState } from "react";

const cloudinaryOptimized = (src) => {
  if (!src || typeof src !== "string" || !src.includes("res.cloudinary.com")) return src;
  if (src.includes("/upload/f_auto") || src.includes("/upload/q_auto")) return src;
  return src.replace("/upload/", "/upload/f_auto,q_auto/");
};

const ProgressiveImage = ({
  src,
  alt,
  className = "",
  wrapperClassName = "",
  width,
  height,
  loading = "lazy",
  fetchPriority,
  onLoad,
}) => {
  const [loaded, setLoaded] = useState(false);
  const safeSrc = cloudinaryOptimized(src);

  useEffect(() => {
    setLoaded(false);
  }, [safeSrc]);

  if (!safeSrc) return null;

  return (
    <div className={`progressive-image-wrap ${wrapperClassName}`.trim()}>
      <img
        src={safeSrc}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        className={`${className} progressive-image ${loaded ? "is-loaded" : "is-loading"}`}
        onLoad={(e) => {
          setLoaded(true);
          onLoad?.(e);
        }}
      />
    </div>
  );
};

export default ProgressiveImage;
